import { columns } from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/purchase'
export const namespace = 'purchase'
export const clientRoute = '/purchase'
export const dependencies = ['person', 'purchaseType', 'purchaseContract', 'contract', 'fundAccountType', 'event', 'eventDate', 'address']
export const params = {
  include: 'person,purchaseType,purchaseContract[contract],fundAccountType,event[eventDate],address'
}
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'status'
const subtitleColumn = 'amount'
const infoColumns = ['date', 'purchaseType', 'fundAccountType', 'person', 'event']
// const infoColumns = ['date']
/* --------------------------- */

const state = {
  defaultSort: '-id',
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  titleColumn,
  subtitleColumn,
  infoColumns
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
